module.exports = __webpack_public_path__ + "img/SES_500280501.ba11dc58.jpg";